import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-331" data-mp="1n0ae5ipn6ux5">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-332" data-mp="1mzsaw24kbgfq">
        <div className="mx-auto max-w-2xl text-center" data-id="element-333" data-mp="1r0ubone4o0jt">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-334" data-mp="1qz9j33bdirol">
            ⭐ What other dentists are saying
          </p>

          <div className="mt-4 flex flex-col items-center" data-id="element-335" data-mp="1i1z3j5riwgdv">
            <div className="flex items-center gap-1" aria-hidden="true" data-id="element-336" data-mp="1416bqsslvzeg">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-5 w-5 fill-gold-500 text-gold-500" data-id="element-337" data-mp="181zxbfikt246" />)}
            </div>
            <p className="mt-2 font-display text-3xl font-bold text-navy-900" data-id="element-338" data-mp="32gsp13gc98qu">
              4.9<span className="text-lg text-navy-700/50" data-id="element-339" data-mp="32eolwnq9kdrm">/5</span>
            </p>
            <p className="mt-2 max-w-sm text-[14px] leading-snug text-navy-700/75" data-id="element-340" data-mp="2uzrjl4h3phln">
              Professionals looking for a more structured way to organize their
              occlusal analysis.
            </p>
          </div>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-341" data-mp="2zskphvob2vzb">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-3xl border border-navy-900/10 bg-cream-100 p-5 shadow-card" data-id="element-342" data-mp="2c26srrus08ye">
              <div className="flex items-center gap-1" aria-hidden="true" data-id="element-343" data-mp="2m0wejvpsmdjx">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-gold-500 text-gold-500" data-id="element-344" data-mp="2h1jqj7n6r0fr" />)}
              </div>

              <blockquote className="mt-3.5 flex-1 text-[14.5px] leading-relaxed text-navy-800/90" data-id="element-345" data-mp="3shhsysnuyo80">
                “{testimonial.quote}”
              </blockquote>

              <div className="mt-5 flex items-center gap-3 border-t border-navy-900/10 pt-4" data-id="element-346" data-mp="3gv9yja22wsn">
                <img src={testimonial.photo} alt={`${testimonial.name}, dentist from ${testimonial.country}`} className="h-11 w-11 shrink-0 rounded-full object-cover" width={88} height={88} loading="lazy" data-id="element-347" data-mp="8fyb3smx0ivc" />
                <div className="min-w-0" data-id="element-348" data-mp="3lsi6wsl88lwr">
                  <p className="truncate text-[14px] font-extrabold text-navy-900" data-id="element-349" data-mp="3lt9srbp0v59u">
                    {testimonial.name}{' '}
                    <span aria-hidden="true" data-id="element-350" data-mp="3qq07nvp3buto">{testimonial.flag}</span>
                  </p>
                  <p className="text-[12.5px] font-medium text-navy-700/65" data-id="element-351" data-mp="3vkny403nmzaw">
                    {testimonial.country}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 w-full max-w-md" data-id="element-352" data-mp="1k75pkqlz6ftf">
          <CTAButton label="I want to feel this confident" subline="Instant access · One-time payment of $27 USD" data-id="element-353" data-mp="1k6m97ebz3zhi" />
        </div>
      </div>
    </section>;
}